// src/store/slices/userProfileSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SpecieProfileState {
    selectedView: string;
}

const initialState: SpecieProfileState = {
    selectedView: 'info',
};

const specieProfileSlice = createSlice({
    name: 'specieProfile',
    initialState,
    reducers: {
        setSelectedView(state, action: PayloadAction<string>) {
            state.selectedView = action.payload;
        },
    },
});

export const { setSelectedView } = specieProfileSlice.actions;
export default specieProfileSlice.reducer;